import React, { useRef, useImperativeHandle, useState } from 'react';
import { Justify, Button, Bubble } from 'tea-component';
import DynamicFilter from '@gp/components/DynamicFilter';
import FilterSave from '@gp/components/FilterCommon/components/FilterSave';
import useSaveInput from '@gp/components/FilterCommon/components/FilterSave/useSaveInput';
import CardSlot from '@gp/components/CardSlot';
import SvgIcon from '@/pages/home/components/SvgIcon';
import {
  setFilterStorageValue,
  formatStorageValue,
  deleteFilterSaveValue,
  setFilterSaveValue,
  deleteFilterSaveSelectedValue,
  setFilterSaveSelectedValue,
} from '@gp/utils/utils';
import { setStorageValue } from '@gp/components/FilterCommon/components/FilterSave/util';
import { isEmpty } from 'lodash';

/* 复杂下拉需要开发处理 */
export default function FilterBox(props: any) {
  const {
    confirm,
    keyOperateShowOptions = ['confirm', 'reset'],
    confirmRef,
    isPreviews = false,
    controls,
    value,
    onChange: onChangeProps,
    fields,
    onReset,
    loading,
    selectShow = false,
    filterFixed = false,
    isFilter = false,
    close,
    isHaveFilterSave = true,
    currentPage,
    selectedValue,
    setSelectedValue,
  } = props;

  const isUpdate = useRef(false);
  const [updateTipsShow, setUpdateTipsShow] = useState(false);

  const {
    deleteFilterSaveFetch,
    filterSaveChange,
    filterModalInfo,
    setFilterModalInfo,
    addFilterSaveListFetch,
    filterSaveList,
    getFilterSaveListFetch,
    editFilterSaveFetch,
    saveFilterValue,
    isOperatMyFilter,
    setIsOperatMyFilter,
  } = useSaveInput({
    value,
    currentPage,
    handleChange: onChangeProps,
    selectedValue,
    setSelectedValue,
    fields,
  });

  const backConfirm = () => {
    confirm?.();
    // 手动修改，添加到筛选器继承值
    const formatValue = formatStorageValue(fields, value) || {};

    // 若此次修改有使用保存方案，则缓存保存方案值
    if (isOperatMyFilter && !isEmpty(selectedValue)) {
      setFilterSaveValue(saveFilterValue);
      setFilterSaveSelectedValue(selectedValue);
    } else {
      // 如果是修改筛选器保存方案之外的，则清空筛选器保存方案缓存
      deleteFilterSaveValue();
      deleteFilterSaveSelectedValue();
      setFilterStorageValue(setStorageValue(formatValue, fields));
      // 重置筛选器方案下拉框，同时删除筛选器方案的缓存
      setSelectedValue?.({});
    }
  };

  const resetTips = () => {
    setUpdateTipsShow(false);
    isUpdate.current = false;
  };

  const reset = () => {
    onReset?.();
    // 重置筛选器方案下拉框，同时删除筛选器方案的缓存
    setSelectedValue?.({});
  };

  useImperativeHandle(
    confirmRef,
    () =>
      ({
        click: () => backConfirm(),
        reset: () => reset(),
      } as any),
  );

  const filterBox = useRef<HTMLDivElement>(null);

  const ConfirmBtnElement = () => {
    const btn = (
      <Button
        disabled={loading}
        type="primary"
        onClick={() => {
          backConfirm();
        }}
      >
        {'Confirm'}
      </Button>
    );

    return btn;
  };

  const maskClick = () => {
    if (isUpdate.current && updateTipsShow) {
      close?.();
      resetTips();

      return;
    }

    if (isUpdate.current) {
      setUpdateTipsShow(true);
    } else {
      close?.();
    }
  };

  const handleChange = (value: any) => {
    setIsOperatMyFilter(false);
    onChangeProps?.(value);
  };

  return (
    <CardSlot
      className={`dbg-filter-box-wrapper ${isPreviews && 'dbg-filterbox-preview'}`}
      bodyStyle={loading ? { minHeight: 112, lineHeight: '88px' } : {}}
      loading={loading}
    >
      <>
        <div className={'dbg-filter-box'}>
          {/* 这里使用loading添加一个loading态 */}
          <div className="dbg-filter-box-flex" ref={filterBox}>
            <div className="dbg-filter-common-box-wrapper">
              <DynamicFilter
                fields={fields}
                controls={controls}
                value={value}
                onChange={handleChange}
                isNeedDiff={true}
                isFilter={isFilter}
                inputSlot={
                  <>
                    {isHaveFilterSave && (
                      <FilterSave
                        filterModalInfo={filterModalInfo}
                        setFilterModalInfo={setFilterModalInfo}
                        selectedValue={selectedValue}
                        fields={fields}
                        controls={controls}
                        filterValue={value}
                        filterSaveChange={filterSaveChange}
                        addFilterSaveListFetch={addFilterSaveListFetch}
                        getFilterSaveListFetch={getFilterSaveListFetch}
                        deleteFilterSaveFetch={deleteFilterSaveFetch}
                        editFilterSaveFetch={editFilterSaveFetch}
                        currentPage={currentPage}
                        filterSaveList={filterSaveList}
                      />
                    )}
                  </>
                }
              />
            </div>
          </div>
          <Justify
            className="dbg-filter-box-justify"
            left={
              <>
                {keyOperateShowOptions.includes('confirm') && ConfirmBtnElement()}
                {keyOperateShowOptions.includes('reset') && (
                  <Button type="weak" onClick={reset}>
                    {'Reset'}
                  </Button>
                )}
                {isHaveFilterSave && (
                  <Bubble
                    dark
                    content={filterSaveList?.length >= 10 ? 'Up to 10 settings can be saved' : ''}
                  >
                    <Button
                      type="weak"
                      className="tea-btn--weak"
                      onClick={() => {
                        setFilterModalInfo({
                          filterModalType: 'add',
                          filterModalVisible: true,
                        });
                      }}
                      disabled={filterSaveList?.length >= 10}
                    >
                      {'Save as My Filter'}
                    </Button>
                  </Bubble>
                )}
              </>
            }
            right={
              selectShow &&
              filterFixed && (
                <Button type="link" className="dbo-filterbox-btn" onClick={() => close?.()}>
                  <div className="filterbox-right">
                    <span>{'Close'}</span>
                    <SvgIcon type="point-top" className="filterbox-right-icon" />
                  </div>
                </Button>
              )
            }
          />
          <div className="mask" onClick={maskClick}></div>
        </div>
      </>
    </CardSlot>
  );
}
